import apiHandler from '../core/apiHandler';

const dteBulkDownloadApi = apiHandler('sales');

export default dteBulkDownloadApi;
